import { useFlags } from "launchdarkly-react-client-sdk";

export const useHideMicroPaths = () => {
  const { hideMicroPaths } = useFlags();

  return hideMicroPaths;
};

export const useHideTimeSpent = (): boolean => {
  const { hideTimeSpent } = useFlags();

  return hideTimeSpent ?? false;
};
